<template>
  <div class="extend_time__form">
    <!-- สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.) -->
    <div class="custom_card mt-4">
      <v-layout justify-space-between pa-3>
        <v-flex shrink class="pr-4">
          <v-img
            :src="
              require('../../../../assets/images/extension-time/logo-rsp.png')
            "
            width="100"
            height="100"
          ></v-img>
        </v-flex>
        <v-flex xs8>
          <h1>
            สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
            (สป.อว.)
          </h1>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่เปิดรับโครงการ 31 พฤศจิกายน 2565 เวลา 00:00 น. - 30 ธันวาคม
              2565 เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่พิจารณาโครงการ 3 มกราคม 2566 เวลา 08:00 น. - 5 มกราคม 2566
              เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 pl-6 mt-2">
            โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์
            (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
          </div>
        </v-flex>
        <v-spacer />
        <v-flex shrink>
          <div
            class="custom_card d-flex flex-column align-center justify-center"
            style="
              background-color: #f15a29;
              color: #fff;
              width: 100px;
              height: 100px;
              padding: 5px;
            "
          >
            <div class="font-20 font-w-600">ปี งปม.</div>
            <div class="font-32 font-w-600">2566</div>
            <div></div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation class="mt-6">
      <div class="font-20 font-w-600 mb-4">แผนงาน</div>
      <div class="font-16 font-w-600 mb-6 custom_card">
        {{ plan_name }}
      </div>

      <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

      <table v-if="form?.pending_form_list?.length > 0" class="custom_table mb-4">
        <thead>
          <tr>
            <th width="5%">ลำดับ</th>
            <th width="45%">ชื่อโครงการ</th>
            <th width="10%">มหาวิทยาลัย</th>
            <th width="10%">ผู้นำเข้าข้อมูล</th>
            <th width="10%" class="text-center">ครั้งที่</th>
            <th width="10%" class="text-center">ระยะที่ขอขยาย</th>
            <th width="10%" class="text-center">ขยายถึง</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in form.pending_form_list" :key="i">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.project_name" />
              </div>
            </td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.user?.university?.name_th" />
              </div>
            </td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.created_by" />
              </div>
            </td>
            <td class="text-center">{{ item.round }}</td>
            <td class="text-center">{{ item.duration }}</td>
            <td class="text-center">{{ item.end_date }}</td>
          </tr>
        </tbody>
      </table>


      <div class="custom_card">
        <v-layout class="mt-6">
          <v-flex xs12>
            <div class="font-14 font-w-600 mb-2">
              เหตุผล <span style="color: #f15a29">*</span>
            </div>
            <v-textarea
              v-model="form.reason_rsp"
              outlined
              dense
              rows="5"
              color="#D3D3D3"
              style="border-radius: 30px"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุเหตุผล']"
              required
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-space-between>
          <v-flex shrink class="font-14 font-w-700 mb-2">เอกสารเเนบ</v-flex>
          <v-flex shrink>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#F15A29"
              @click="addFile"
            >
              <v-icon class="font-12 font-w-700" left>mdi-plus</v-icon>
              <span class="font-12 font-w-700">เพิ่มไฟล์</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <div class="font-14" style="color: #f15a29">
          *ไฟล์ที่ระบบรองรับ .PDF (สูงสุด 50 MB/ไฟล์)
        </div>
        <v-layout
          class="mt-3 custom_file_input"
          v-for="(file, f) in form.files"
          :key="f"
        >
          <v-flex xs7>
            <v-file-input
              :id="'file' + f"
              color="#F15A29"
              :clearable="false"
              style="border-radius: 30px"
              outlined
              height="36"
              placeholder=""
              prepend-icon=""
              hide-input
              accept="application/pdf,.pdf"
              @change="handleUploadFile($event, f)"
            ></v-file-input>
            <v-text-field
              v-model="file.file_name"
              outlined
              height="36"
              color="#F15A29"
              style="border-radius: 30px"
              readonly
              :rules="[(v) => !!v || 'กรุณาแนบเอกสาร']"
              clearable
              @click:clear="clearFile(f)"
            ></v-text-field>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#464647"
              @click="uploadFile(f)"
            >
              <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
              <span class="font-12 font-w-700">อัพโหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              height="35"
              width="35"
              fab
              dark
              color="#FD0C0C"
              @click="removeFile(f)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-layout class="mt-5">
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#D9D9D9"
            @click="$router.go(-1)"
          >
            <span class="font-14 font-w-700" style="color: #464647">
              ยกเลิก
            </span>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink mr-4>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#FBB040"
            @click="onDraft()"
          >
            <span class="font-14 font-w-700">บันทึกฉบับร่าง</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
import axios from "axios";
import { apiDomain } from "../../../../store/constants";

export default {
  components: { DatePicker },
  data() {
    return {
      valid: true,
      plan_name: "",
      form: {
        pending_group_id: null,
        plan_id: null,
        plan_master_id: null,
        fiscal_year: null,
        region: null,
        reason_rsp: null,
        files: [],
        pending_form_list: [],
      },
      rulesFile: [
        (value) =>
          !value ||
          value.size < 50000000 ||
          "File size should be less than 50 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    };
  },
  created() {
    console.log(this.$route.params);

    if (this.$route.params.id) {
      // edit
      this.onEdit();
    } else {
      // create
      this.onCreate();
    }
  },
  methods: {
    async onCreate() {
      let res = await this.$apiFire("RSPExtend/create", {
        plan_id: this.$route.params.plan_id,
        pending_group_id: this.$route.params.pending_group_id,
      });

      if (res) {
        console.log('res', res);
        // set master data
        this.plan_name = res.plan.plan_master.plan_name_th;
        this.form.pending_form_list = res.pending_form_list;

        // set form data
        this.form.pending_group_id = this.$route.params.pending_group_id;
        this.form.plan_id = this.$route.params.plan_id;
        this.form.plan_master_id = res.plan.plan_master_id;
        this.form.fiscal_year = res.plan.main_project.fiscal_year;
        this.form.region = res.pending_group.region;
      }
    },

    async onEdit() {
      let res = await this.$apiFire("RSPExtend/edit", {
        id: this.$route.params.id,
        plan_id: this.$route.params.plan_id,
        pending_group_id: this.$route.params.pending_group_id,
      });

      if (res) {
        // set master data
        this.plan_name = res.plan.plan_master.plan_name_th;
        this.form.pending_form_list = res.pending_form_list;
        // set form data
        this.form.pending_group_id = res.data.pending_group_id;
        this.form.plan_id = res.data.plan_id;
        this.form.plan_master_id = res.data.plan_master_id;
        this.form.fiscal_year = res.data.fiscal_year;
        this.form.region = res.data.region;
        this.form.reason_rsp = res.data.reason_rsp;

        // set files data
        res.data.pending_sub_group_attachments.forEach((file) => {
          this.form.files.push({
            id: file.attachment.id,
            parent_table: file.attachment.parent_table,
            parent_id: file.attachment.parent_id,
            file_name: file.attachment.file_name,
            file_path: file.attachment.file_path,
            file_extension: file.attachment.file_extension,
            full_path: file.attachment.full_path,
          });
        });
      }
    },

    clearFile(id) {
      this.form.files[id] = {
        parent_table: null,
        parent_id: null,
        file_name: null,
        file_path: null,
        file_extension: null,
        full_path: null,
      };
      // clear value input file
      document.querySelector("#file" + id).value = "";
      console.log(this.form.files[id]);
      this.$forceUpdate();
    },

    addFile() {
      this.form.files.push({
        parent_table: null,
        parent_id: null,
        file_name: null,
        file_path: null,
        file_extension: null,
        full_path: null,
      });
    },

    removeFile(id) {
      this.form.files.splice(id, 1);
    },

    uploadFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },

    async handleUploadFile(file, index) {
      if (!file) {
        return;
      }

      const isPdfFile =
        file.type === "application/pdf" ||
        file.name?.toLowerCase().endsWith(".pdf");

      if (!isPdfFile) {
        this.$store.commit('General/setModal', {
          title: 'รองรับเฉพาะไฟล์ PDF',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์นามสกุล .PDF เท่านั้น',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        this.form.files.pop()
        return
      }

      if(file.size > 50000000){
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        //remove file in to last index of attachment
        this.form.files.pop()
        return
      }
      let file_id = this.form.files[index].id;
      let parent_table = this.form.files[index].parent_table;
      let parent_id = this.form.files[index].parent_id;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folder", "/uploads/pending-group-rsp/");
      const res = await axios.post(`${apiDomain}api/upload-file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status == 200) {
        this.form.files[index] = res.data.attachments;
        if (file_id) {
          this.form.files[index].id = file_id;
          this.form.files[index].parent_table = parent_table;
          this.form.files[index].parent_id = parent_id;
        }
        this.$forceUpdate();
      } else {
        this.$store.commit("General/setModal", {
          title: "Something went wrong!",
          showCancel: false,
          theme: "error",
          buttonText: "OK",
          text: res.data.message,
        });
      }
    },

    checkValType(val) {
      return typeof val;
    },

    async onDraft() {
      if (this.$refs.form.validate()) {
        this.form.status = "Created";
        let res = null;
        if (this.$route.params.id) {
          // update
          res = await this.$apiFire("RSPExtend/update", {
            id: this.$route.params.id,
            data: this.form,
          });
        } else {
          res = await this.$apiFire("RSPExtend/store", this.form);
        }

        if (res) {
          this.$router.push("/rsp/extend-time");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.extend_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }

  .custom_table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    thead {
      // background-color: #f2f2f2;
      color: #b1b1b1;
      th {
        padding: 12px;
        border-bottom: 1px solid #ddd;
        text-align: left;
      }
    }
    tbody {
      tr {
        &:nth-child(even) {
          // background-color: #f2f2f2;
        }
        td {
          padding: 12px;
        }
      }
    }
  }

  .custom_file_input {
    .v-text-field--full-width .v-input__prepend-outer,
    .v-text-field--full-width .v-input__prepend-inner,
    .v-text-field--full-width .v-input__append-inner,
    .v-text-field--full-width .v-input__append-outer,
    .v-text-field--enclosed .v-input__prepend-outer,
    .v-text-field--enclosed .v-input__prepend-inner,
    .v-text-field--enclosed .v-input__append-inner,
    .v-text-field--enclosed .v-input__append-outer {
      margin-top: 4px !important;
    }
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: inherit !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  .v-input__icon--clear {
    background: #d9d9d9;
    color: #fff !important;
  }

  .btn-save {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 0px 10px;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
